export default __webpack_public_path__ + "static/media/src_jquery_desktop_4.7744bf3d.jpg";